import { Component } from '@angular/core';

import { expandCollapseAnimation } from '../../animations/expand-collapse.animation';
import { PageLevelMessageService } from './page-level-message.service';

/**
 * Component for displaying page level messages.
 *
 * @author Jesse Bloomster e020902
 */
@Component({
	selector: 'claim-tracker-page-level-message',
	standalone: true,
	templateUrl: './page-level-message.component.html',
	animations: [expandCollapseAnimation()]
})
export class PageLevelMessageComponent {
	messages = this.messageService.messages;

	/**
	 * @param messageService service for handling messages
	 */
	constructor(private messageService: PageLevelMessageService) {}
}
